import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {
  private readonly STORAGE_KEY = 'immovea_favorites';
  private favoriteIds = signal<Set<string>>(new Set());

  constructor() {
    this.loadFromLocalStorage();
  }

  private loadFromLocalStorage(): void {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const ids = JSON.parse(stored) as string[];
        this.favoriteIds.set(new Set(ids));
      }
    } catch (error) {
      console.error('Error loading favorites from localStorage:', error);
    }
  }

  private saveToLocalStorage(): void {
    try {
      const ids = Array.from(this.favoriteIds());
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(ids));
    } catch (error) {
      console.error('Error saving favorites to localStorage:', error);
    }
  }

  toggleFavorite(propertyId: string): void {
    const favorites = this.favoriteIds();
    const newFavorites = new Set(favorites);
    
    if (newFavorites.has(propertyId)) {
      newFavorites.delete(propertyId);
    } else {
      newFavorites.add(propertyId);
    }
    
    this.favoriteIds.set(newFavorites);
    this.saveToLocalStorage();
  }

  isFavorite(propertyId: string): boolean {
    return this.favoriteIds().has(propertyId);
  }

  getFavoriteIds(): string[] {
    return Array.from(this.favoriteIds());
  }

  getFavoriteCount(): number {
    return this.favoriteIds().size;
  }

  clearAllFavorites(): void {
    this.favoriteIds.set(new Set());
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
